export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas px-4">
      <div className="card max-w-[420px] w-full">
        <div className="card-bd flex flex-col items-center gap-4 py-8">
          {/* Brand lockup */}
          <div className="flex items-baseline gap-2">
            <span className="brace text-[36px]">
              {'{'}
              <span className="eyes">::</span>
              {'}'}
            </span>
            <span className="text-fg font-semibold tracking-[-0.01em] text-[28px] leading-none">
              samik<span className="text-accent">.</span>
              <span className="text-fg-dim font-normal">sh</span>
            </span>
          </div>

          <p className="m-0 text-[12px] text-fg-muted text-center max-w-[300px] leading-relaxed">
            Autonomous code-review agent for GitHub pull requests.
          </p>

          <a
            href="/auth/login"
            className="btn btn-primary text-[13px] px-5 py-2 no-underline mt-2"
          >
            Sign in with GitHub
          </a>
        </div>
      </div>
    </div>
  )
}
